import React, { Component } from 'react'
import PropTypes from 'prop-types'
import '../styles/video.css'
import ReactPlayer from 'react-player'

class MediaPlayer extends Component {
  constructor () {
    super()
    this.state = {
      volume: 0,
      playing: true
    }
  }
  openCloseVideo (videoContainerID, videoOverlayID) {
    if (this.props.active !== true) {
      return
    }
    const videoContainer = document.getElementById(videoContainerID)
    const videoOverlay = document.getElementById(videoOverlayID)

    if (this.state.volume === 0) {
      document.getElementById('navButton').style.display = 'none'
      this.player.seekTo(0)
      this.setState({volume: 1})
      videoContainer.classList.add('cinematic')
      videoOverlay.style.display = 'block'
      setTimeout(function () {
        videoOverlay.classList.add('cinematic')
      }, 0)
      window.addEventListener('DOMMouseScroll', this.lockScroll, false)
      window.onwheel = this.lockScroll
      window.onmousewheel = document.onmousewheel = this.lockScroll
      window.ontouchmove = this.lockScroll
      document.onkeydown = this.lockScrollKeys
    } else {
      document.getElementById('navButton').style.display = 'inline-block'
      this.setState({volume: 0})
      videoContainer.classList.remove('cinematic')
      videoOverlay.classList.remove('cinematic')
      setTimeout(function () {
        videoOverlay.style.display = 'none'
      }, 300)
      window.removeEventListener('DOMMouseScroll', this.lockScroll, false)
      window.onmousewheel = document.onmousewheel = null
      window.onwheel = null
      window.ontouchmove = null
      document.onkeydown = null
    }
  }
  lockScrollKeys (e) {
    const keys = {37: 1, 38: 1, 39: 1, 40: 1}
    if (keys[e.keyCode]) {
      e.preventDefault()
      return false
    }
  }
  lockScroll (e) {
    e = e || window.event
    if (e.preventDefault) {
      e.preventDefault()
    }
    e.returnValue = false
  }
  seekVideo (seekBarID, seekProgressID) {
    const seekBar = document.getElementById(seekBarID)
    const seekProgress = document.getElementById(seekProgressID)
    const time = this.player.getDuration() * (seekBar.value / 100)
    this.player.seekTo(parseFloat(time))
    seekProgress.style.width = seekBar.value + '%'
  }
  timeUpdate (seekBarID, seekProgressID) {
    const seekBar = document.getElementById(seekBarID)
    const seekProgress = document.getElementById(seekProgressID)
    var value = (100 / this.player.getDuration()) * this.player.getCurrentTime()
    seekBar.value = value
    seekProgress.style.width = seekBar.value + '%'
  }
  scrubVideoPause () {
    this.setState({playing: false})
  }
  scrubVideoPlay () {
    this.setState({playing: true})
  }
  render () {
    const { volume, playing } = this.state
    return (
      <div className='videoContainer' id={this.props.options.video + '_container'}>
        <div className='videoCard' id={this.props.options.video + '_card'}
          onClick={() => this.openCloseVideo(this.props.options.video + '_container', this.props.options.video + '_overlay')}>
          <div className='video'>
            <ReactPlayer id={this.props.options.video + '_video'}
              url={'https://vimeo.com/' + this.props.options.video}
              loop playsinline
              playing={playing}
              volume={volume}
              width='100%' height='100%'
              ref={player => { this.player = player }}
              onProgress={() => this.timeUpdate(this.props.options.video + '_seekInput', this.props.options.video + '_seekProgress')} />
          </div>
        </div>
        <div className='videoSeek'>
          <div className='seekProgress' id={this.props.options.video + '_seekProgress'} />
          <div className='seekBar' id={this.props.options.video + '_seekBar'} />
          <input type='range' id={this.props.options.video + '_seekInput'}
            onMouseDown={() => this.scrubVideoPause()}
            onMouseUp={() => this.scrubVideoPlay()}
            onChange={() => this.seekVideo(this.props.options.video + '_seekInput', this.props.options.video + '_seekProgress')} />
        </div>
        <div className='videoOverlay'
          id={this.props.options.video + '_overlay'}
          onClick={() => this.openCloseVideo(this.props.options.video + '_container', this.props.options.video + '_overlay')} />
      </div>
    )
  }
}

MediaPlayer.propTypes = {
  options: PropTypes.object.isRequired,
  active: PropTypes.bool
}

export default MediaPlayer



// WEBPACK FOOTER //
// ./src/components/MediaPlayer.js